import { render, staticRenderFns } from "./reports.vue?vue&type=template&id=2c48a75f"
import script from "./reports.vue?vue&type=script&lang=js"
export * from "./reports.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports